<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12">
        <div class="text-h4 primary--text d-flex align-center px-4">
          <v-btn
            icon
            class="mr-2"
            @click="$router.push({ name: 'HomeProfesor' })"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          Informes de Progreso
        </div>
        <div class="text-body-2 grey--text px-4 mb-4">
          Una clase cuenta como completada cuando el alumno terminó sus videos,
          acertó sus actividades SCORM y entregó sus actividades IEA.
        </div>

        <div v-if="cargando" class="text-center py-8">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <div v-else-if="!cursos.length" class="text-center grey--text py-8">
          No tenés cursos asignados.
        </div>

        <v-row v-else>
          <v-col v-for="curso in cursos" :key="curso.id" cols="12" md="6">
            <v-card class="rounded-lg" elevation="2">
              <v-card-title class="informe-header white--text py-2">
                <span class="text-subtitle-1 font-weight-bold">{{
                  curso.nombre
                }}</span>
                <v-spacer />
                <v-btn small text dark @click="irCurso(curso)"
                  >Ir al curso</v-btn
                >
              </v-card-title>

              <v-card-text class="pt-3">
                <div v-if="curso.cargando" class="text-center py-4">
                  <v-progress-circular
                    indeterminate
                    size="24"
                    color="primary"
                  />
                </div>
                <div v-else-if="curso.error" class="grey--text">
                  No se pudo cargar el avance de este curso.
                </div>
                <div v-else-if="!curso.alumnos.length" class="grey--text">
                  Sin alumnos inscriptos.
                </div>

                <template v-else>
                  <div class="d-flex align-center mb-1">
                    <span class="text-body-2">
                      {{ curso.alumnos.length }} alumnos · avance promedio
                    </span>
                    <v-spacer />
                    <span class="font-weight-bold">{{ promedio(curso) }}%</span>
                  </div>
                  <v-progress-linear
                    :value="promedio(curso)"
                    :color="color(promedio(curso))"
                    height="10"
                    rounded
                    class="mb-3"
                  />

                  <div class="d-flex flex-wrap mb-3">
                    <v-chip small class="mr-2 mb-1" color="#4CAF50" dark>
                      Al día (70%+): {{ franja(curso, 70, 101) }}
                    </v-chip>
                    <v-chip small class="mr-2 mb-1" color="#FF9800" dark>
                      40–69%: {{ franja(curso, 40, 70) }}
                    </v-chip>
                    <v-chip small class="mb-1" color="#F44336" dark>
                      Menos de 40%: {{ franja(curso, 0, 40) }}
                    </v-chip>
                  </div>

                  <div class="font-weight-bold text-body-2 mb-2">
                    Necesitan atención
                  </div>
                  <div
                    v-for="alumno in atrasados(curso)"
                    :key="alumno.id"
                    class="d-flex align-center mb-2"
                  >
                    <div class="flex-grow-1 text-body-2">
                      {{ alumno.nombre }}
                    </div>
                    <span class="text-caption grey--text mr-2">
                      {{ alumno.completadas }}/{{ alumno.total }} clases
                    </span>
                    <span
                      class="text-caption font-weight-bold"
                      :style="{ color: color(alumno.porcentaje) }"
                    >
                      {{ alumno.porcentaje }}%
                    </span>
                  </div>
                  <div
                    v-if="!atrasados(curso).length"
                    class="text-body-2 grey--text"
                  >
                    Todos los alumnos van al día.
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "InformesProgreso",
  components: { CardIeaAppMain },
  data() {
    return {
      cargando: true,
      cursos: []
    };
  },
  async mounted() {
    try {
      const res = await this.$API.get({ url: "profesor-clases-v2", data: {} });
      const lista = res && Array.isArray(res.data) ? res.data : [];
      this.cursos = lista.map(c => ({
        id: c.id,
        materia_id: c.materia_id,
        materia_codigo_id: c.materia_codigo_id,
        nombre: c.materia || c.nombre || "Curso sin nombre",
        cargando: true,
        error: false,
        alumnos: []
      }));
    } catch (e) {
      this.cursos = [];
    } finally {
      this.cargando = false;
    }
    // ponytail: un request por curso (pocos cursos por docente); endpoint agregado si crece
    this.cursos.forEach(curso => this.cargarCurso(curso));
  },
  methods: {
    async cargarCurso(curso) {
      try {
        const res = await this.$API.get(
          { url: "profesor/lista-alumnos-v6/" + curso.id },
          false
        );
        const data = res && Array.isArray(res.data) ? res.data : [];
        // v6 puede repetir un alumno (GROUP BY alumno + nombre de materia): uno por id
        const unicos = [...new Map(data.map(a => [a.id_alumno, a])).values()];
        curso.alumnos = unicos.map(a => ({
          id: a.id_alumno,
          nombre: a.fullname || "Alumno",
          porcentaje: a.avance ? Number(a.avance.porcentaje) || 0 : 0,
          completadas: a.avance ? a.avance.completadas : 0,
          total: a.avance ? a.avance.total : 0
        }));
      } catch (e) {
        curso.error = true;
      } finally {
        curso.cargando = false;
      }
    },
    promedio(curso) {
      if (!curso.alumnos.length) return 0;
      const suma = curso.alumnos.reduce((t, a) => t + a.porcentaje, 0);
      return Math.round(suma / curso.alumnos.length);
    },
    franja(curso, desde, hasta) {
      return curso.alumnos.filter(
        a => a.porcentaje >= desde && a.porcentaje < hasta
      ).length;
    },
    atrasados(curso) {
      return curso.alumnos
        .filter(a => a.porcentaje < 40)
        .sort((a, b) => a.porcentaje - b.porcentaje)
        .slice(0, 5);
    },
    color(valor) {
      if (valor >= 70) return "#4CAF50";
      if (valor >= 40) return "#FF9800";
      return "#F44336";
    },
    irCurso(curso) {
      this.$router.push({
        name: "GestionCurso",
        params: {
          cursoId: curso.id,
          cursoNombre: curso.nombre.replace(/\./g, "")
        },
        query: {
          materia_id: curso.materia_id,
          materia_codigo_id: curso.materia_codigo_id
        }
      });
    }
  }
};
</script>

<style scoped>
.informe-header {
  background-color: #f9a825;
}
</style>
